import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Observable, catchError, switchMap, throwError } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class InterceptorService implements HttpInterceptor {
    // Lista de URLs que no requieren el encabezado de autorización
    private excludedUrls: string[] = [
        environment.services.IpService
    ];

    constructor(
        private oAuthenticationService: AuthenticationService
    ) { }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const isExcludedUrl = this.excludedUrls.some((url) =>
            request.url.includes(url)
        );
        if (!isExcludedUrl) {
            let token = this.oAuthenticationService.getToken();
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`,
                },
            });
        }
        return next.handle(request);
    }
}
